// Fill your Supabase details here or keep your existing file
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://zijpfplhgrszhfgpbbwz.supabase.co";
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppanBmcGxoZ3JzemhmZ3BiYnd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg1Mjk5NDMsImV4cCI6MjA3NDEwNTk0M30.aaXufpN6347d7sHsDE6mcx3AvkeW6H7BgcH7ipp_t_s";

export const supabase = createClient(supabaseUrl, supabaseKey);
